<template>
  <div class="edition-table">
    <table>
      <thead>
        <th class="edition-table__room">Quartos</th>

        <th class="edition-table__close">
          Limite de apartamentos
          <InfoTooltip
            :tooltipMinWidth="'240'"
            text="Caso você queira limitar a quantidade de vendas para essa tarifa, insira o valor máximo que poderá ser vendido por dia de hospedagem."
          />
        </th>

        <th class="edition-table__cta">
          Allot exclusivo tarifa
          <InfoTooltip
            :tooltipMinWidth="'240'"
            text="Quando selecionado esta opção, a quantidade de aptos inserido será exclusivo desta regra tarifária"
          />
        </th>
      </thead>
      <tbody>
        <!-- LINHA -->
        <tr
          v-for="(room, i) in allotmentRooms"
          :key="`room-${room.codigoQuarto || i}`"
        >
          <!-- QUARTOS -->
          <td class="td__padd--room">
            {{
              hotelRoomsData.find((item) => +item.codigo === +room.codigoQuarto)
                ?.nome
            }}
          </td>

          <!-- LIMITE DE APARTAMENTOS -->
          <td class="td__padd">
            <TableInputCell
              v-model="room.allotment"
              :id="`${room.codigoQuarto}-limit`"
              :currency="true"
              :min="0"
              :max="100"
              type="number"
              placeholder=""
              class="edition-table__input"
              @focus="$event.target.select()"
            />
          </td>

          <!-- ALLOT EXCLUSIVO DE TARIFA -->
          <td class="td__padd">
            <InputCheckbox
              v-model="room.allotmentExclusivoTarifa"
              :checked="room.allotmentExclusivoTarifa"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/** ======================================================= */
/** Componente da tabela de visualização de edição de allotment */
/** ======================================================= */
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import TableInputCell from '@/components/hotel/allotmentAndRatesCalendar/TableInputCell'

export default {
  name: 'AllotmentEditionTable',
  components: {
    InputCheckbox,
    InfoTooltip,
    TableInputCell
  },
  props: {
    /** Configuração dos quartos */
    allotmentRooms: {
      type: Array,
      default: () => []
    },

    hotelRoomsData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
$cell-padding: 12px 12px;

.tooltip-space {
  margin-left: 7px;
}

.edition-table {
  max-width: 1236px;

  &__input {
    border: 1px solid pmw-colors(grey-40);
    width: 100px;
    margin: 0 auto 0 auto;
  }

  &__room {
    width: 150px;
    text-align: center;
    min-width: 150px;
  }

  &__close {
    width: 150px;
    min-width: 150px;
  }

  &__cta {
    width: 77px;
    min-width: 77px;
  }

  &__ctd {
    width: 77px;
    min-width: 77px;
  }

  &__discount {
    width: 110px;
    min-width: 110px;
  }

  &__value {
    width: 80px;
    min-width: 80px;
  }

  &__disp-lestbook {
    width: 120px;
    min-width: 120px;
  }

  &__restriction {
    width: 170px;
    min-width: 170px;
  }

  table {
    th {
      padding: $cell-padding;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      font-weight: font-weight('weight-medium');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }
    }

    th {
      font-weight: font-weight('weight-medium');
    }

    .td {
      padding: 0;
      min-width: 1px;

      &__padd {
        &--room {
          text-align: center;
          padding: $cell-padding;
        }

        padding: $cell-padding;
        ::v-deep {
          .input-checkbox {
            margin: 0px auto !important;
            display: table;
          }
        }
      }
    }

    .rest-td {
      .td {
        &:first-child {
          border-right: 1px solid $gray-border;
        }

        &:last-child {
          ::v-deep {
            .content-wrapper {
              padding: {
                left: 10px;
                right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
